import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { LensUpstreamVirtualConnectionsQuery, LensUpstreamVirtualConnectionsQueryVariables, VirtualConnectionsDisplayGridRowDataFragment, VirtualConnectionSortOrder , LensUpstreamVirtualConnectionsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  MaxCountsResultData,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { getRowDataWithMaxCountsForVirtualConnection } from '../database/functions/VirtualConnectionRowDataFunctions';
import { VirtualConnectionsDisplayGridRowData } from '../database/types/VirtualConnectionDisplayGridRowData';
import { VirtualConnectionsDisplayGrid } from '../sharedDisplayGrid/VirtualConnectionsDisplayGrid';
import { VirtualConnectionsValidSortFields } from '../sorting/sortProviders/VirtualConnectionsGridSortProvider';

type QueryVariables = LensUpstreamVirtualConnectionsQueryVariables;
type QueryResults = LensUpstreamVirtualConnectionsQuery;
type QueryResultListNode = VirtualConnectionsDisplayGridRowDataFragment;
type GridRowData = VirtualConnectionsDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const first = resultData?.lenses[0]
  if (!first) {
    return null
  }

  return first.upstreamVirtualConnectionsConnection;
}

export type LensUpstreamVirtualConnectionsQueryGridProps =
  GridSortProps<VirtualConnectionsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export const LensUpstreamVirtualConnectionsQueryGrid: React.FC<LensUpstreamVirtualConnectionsQueryGridProps> = props => {
  const emptyGridMessage = Messages.EmptyUpstreamVirtualConnectionsLineageGridMessage();

  return (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={LensUpstreamVirtualConnectionsDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as VirtualConnectionSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForVirtualConnection}
    >
      {({ rowStore }) =>
        <VirtualConnectionsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      }
    </PaginatedQueryWrapper>
  );
};

function getRowDataForVirtualConnection(
  virtualConnection: VirtualConnectionsDisplayGridRowDataFragment,
  resultData: QueryResults,
): VirtualConnectionsDisplayGridRowData {
  return getRowDataWithMaxCountsForVirtualConnection(virtualConnection, selectMaxCountsResult(resultData));
}

function selectMaxCountsResult(resultData: QueryResults): MaxCountsResultData {
  return resultData?.lenses && resultData.lenses[0];
}
